export const name = 'gzFilterDialogController';
export default function gzFilterDialogController(
  columns,
  filters,
  pairingId,
  columnId,
  showServerIndicator,
  $translate,
  $mdDialog,
  $rootScope,
  moment,
  $gzFilters,
  $gzFields,
  $gzAnalytics,
  $timeout
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;
  vm.columns = columns;
  vm.filtersForm = null;

  //
  let stringOps = [
    'equals',
    'notEqual',
    'isEmpty',
    'isNotEmpty',
    'contains',
    'startsWith',
    'endsWith',
  ];

  let numberOps = [
    'equals',
    'notEqual',
    'isEmpty',
    'isNotEmpty',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThan',
    'lessThanOrEqual',
    'between',
  ];

  let dateOps = [
    'equals',
    'isEmpty',
    'isNotEmpty',
    'notEqual',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThan',
    'lessThanOrEqual',
    'between',
    'today',
    'tomorrow',
    'yesterday',
    'thisWeek',
    'nextWeek',
    'lastWeek',
    'future',
    'past',
    'lastSevenDays'
  ];

  let validDateValueOps = [
    'equals',
    'notEqual',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThan',
    'lessThanOrEqual',
  ];

  let validDateRangeOps = [
    'between'
  ];

  let durationOps = [
    'greaterThan',
    'greaterThanOrEqual',
    'lessThan',
    'lessThanOrEqual',
  ];

  let mappedOps = [
    'matchAny',
    'exclude'
  ];

  let myFilters;
  vm.columnClicked = columnClicked;
  vm.showFilter = showFilter;
  vm.filterEnabled = filterEnabled;
  vm.clearFilter = clearFilter;
  vm.stringOpChanged = stringOpChanged;
  vm.stringValueChanged = stringValueChanged;
  vm.numberOpChanged = numberOpChanged;
  vm.numberValueChanged = numberValueChanged;
  vm.numberBeginChanged = numberBeginChanged;
  vm.numberEndChanged = numberEndChanged;
  vm.dateOpChanged = dateOpChanged;
  vm.dateChanged = dateChanged;
  vm.durationOpChanged = durationOpChanged;
  vm.durationValueChanged = durationValueChanged;
  vm.getMappedImage = getMappedImage;
  vm.mappedOpChanged = mappedOpChanged;
  vm.mappedValueChanged = mappedValueChanged;
  vm.toggleMappedValue = toggleMappedValue;
  vm.showDateValue = showDateValue;
  vm.showDateRange = showDateRange;
  vm.submit = submit;
  vm.disableSubmit = disableSubmit;
  vm.toggleEnabled = toggleEnabled;
  vm.toggleClicked = toggleClicked;

  vm.unitTest = {
    getFilters: function() {return myFilters;},
    setFilters: function(f) {myFilters = f;},
    namedFilterModified: namedFilterModified,
    removeFilter: removeFilter,
    initColumnSelection: initColumnSelection,
    getMappedDisplay,
  };

  activate();

  //////////////////

  function activate() {
    vm.showLegend = parseLegend();
    vm.showServerIndicator = vm.showLegend ? showServerIndicator : false;

    initColumnTitles();
    myFilters = _.cloneDeep(filters);
    $gzFilters.mergeFilters(myFilters);

    _.forEach(vm.columns, column => {
      _.set(column, 'internal.enabled', filterEnabled(column));
    });

    let selectedColumn;
    // Select a reasonable default column to select
    if (columnId) {
      // If a column is passed in then we use that
      selectedColumn = _.find(vm.columns, {id: columnId});
      vm.columnId = selectedColumn.id;
      columnClicked(selectedColumn);
      if (vm.selectedColumn && !vm.selectedColumn.internal.enabled) {
        vm.selectedColumn.internal.enabled = true;
        toggleEnabled(vm.selectedColumn);
      }
    }

    if (!selectedColumn) {
      // Look for first enabled column
      _.forEach(vm.columns, column => {
        if (column.internal.enabled) {
          selectedColumn = column;
          columnClicked(selectedColumn);
          return false;
        }
      });

      if (!selectedColumn) {
        // Look for first valid column that supports filters
        _.forEach(vm.columns, column => {
          if (_.get(column, 'options.allowFilter', true)) {
            selectedColumn = column;
            columnClicked(selectedColumn);
            return false;
          }
        });
      }

    }
  }

  function initColumnTitles() {
    _.forEach(vm.columns, column => {
      if (!column.header.title) {
        let title = $gzFields.resolveString(column.header, 'title', column.id);
        _.set(column, 'header.title', title);
      }
    });
  }

  function submit($event) {
    myFilters.userFilter = _.cloneDeep(myFilters.mergedFilter);
    filters.userFilter = myFilters.userFilter;
    let namedFilter = _.get(myFilters, 'namedFilter.and');
    if (namedFilter) {
      if (namedFilterModified()) {
        delete filters.namedFilter;
        $rootScope.$emit('gzNamedFilterChangedEvent', {
          pairingId: pairingId
        });

        $rootScope.$emit('gzFilterRemovedEvent', {
          pairingId: pairingId,
          filterId: myFilters.namedFilter.id
        });
      }
      else {
        _.forEach(namedFilter, item => {
          let colId = item.columnId;
          if (item.and) {
            colId = item.and[0].columnId;
          }
          else if (item.or) {
            colId = item.or[0].columnId;
          }
          _.remove(myFilters.userFilter.and, item => {
            return (item.columnId === colId || (item.or && item.or[0].columnId === colId) || (item.and && item.and[0].columnId === colId));
          });
        });
      }
    }

    var filterData =  myFilters.userFilter.and.map(function(filter) {return filter.columnId+' '+filter.op+' '+filter.value;});

    $gzAnalytics.event('Grid ('+pairingId+') - Column filtered', {label: 'filter : ' + JSON.stringify(filterData)});
    $rootScope.$emit('gzUserFilterChangedEvent', {
      pairingId: pairingId,
      userFilter: myFilters.userFilter
    });

    $mdDialog.hide(myFilters);
  }

  function namedFilterModified() {
    let modified = false;
    let namedFilter = _.get(myFilters, 'namedFilter.and');
    let mergedFilter = _.get(myFilters, 'mergedFilter.and');
    if (!namedFilter) {
      return false;
    }

    _.forEach(namedFilter, item => {
      if (modified) {
        return false;
      }
      if (item.and) {
        let columnId = item.and[0].columnId;
        let found = _.find(mergedFilter, item => {
          return (item.and && item.and[0].columnId === columnId);
        });
        if (found) {
          if (item.and.length !== found.and.length) {
            modified = true;
          }
          else {
            for (let i = 0; i < item.and.length; i++) {
              let filter = item.and[i];
              let test = _.find(found.and, {value: filter.value});
              if (!test) {
                modified = true;
                break;
              }
              else {
                if (filter.op !== test.op) {
                  modified = true;
                  break;
                }
              }
            }
          }
        }
        else {
          modified = true;
        }
      }
      else if (item.or) {
        let columnId = item.or[0].columnId;
        let found = _.find(mergedFilter, item => {
          return (item.or && item.or[0].columnId === columnId);
        });
        if (found) {
          if (item.or.length !== found.or.length) {
            modified = true;
          }
          else {
            for (let i = 0; i < item.or.length; i++) {
              let filter = item.or[i];
              let test = _.find(found.or, {value: filter.value});
              if (!test) {
                modified = true;
                break;
              }
              else {
                if (filter.op !== test.op) {
                  modified = true;
                  break;
                }
              }
            }
          }
        }
        else {
          modified = true;
        }
      }
      else {
        let found = _.find(mergedFilter, {columnId: item.columnId});
        if (found) {
          if (found.op !== item.op || found.value !== item.value) {
            modified = true;
          }
        }
        else {
          modified = true;
        }
      }
    });

    return modified;
  }

  function showDateValue() {
    return validDateValueOps.indexOf(vm.dateOp) >= 0;
  }

  function showDateRange() {
    return validDateRangeOps.indexOf(vm.dateOp) >= 0;
  }

  function columnClicked(column) {
    if (!vm.selectedColumn || vm.selectedColumn.id !== column.id) {
      vm.selectedColumn = column;
      initColumnSelection(column);
      $timeout(() => {
        if (column.internal.enabled) {
          if (vm.filtersForm) {
            vm.filtersForm.$setSubmitted();
          }
        }
        else {
          if (vm.filtersForm) {
            vm.filtersForm.$setPristine();
            vm.filtersForm.$setUntouched();
          }
        }
      });
    }
  }

  function showFilter(column) {
    let showFilter = _.get(column, 'options.allowFilter', true);
    return showFilter && column.type !== 'custom';
  }

  function parseLegend() {
    let hasServerSideFilters = false;
    _.forEach(vm.columns, column => {
      let serverSideFilter = _.get(column, 'options.filter.isServerFilter', false);
      if (serverSideFilter) {
        hasServerSideFilters = true;
        return false;
      }
    });

    return vm.selectedColumn !== undefined && hasServerSideFilters;
  }

  function filterEnabled(column) {
    let found = _.find(myFilters.mergedFilter.and, item => {
      return (item.columnId === column.id || (item.or && item.or[0].columnId === column.id) || (item.and && item.and[0].columnId === column.id));
    });

    if (found) {
      return true;
    }

    return false;
  }

  function clearFilter($event, column) {
    $event.stopPropagation();
    let and = _.get(myFilters, 'mergedFilter.and', []);
    removeColumnFilter(column.id);
    if (vm.selectedColumn && vm.selectedColumn.id === column.id) {
      initColumnSelection(column);
    }
  }

  function removeColumnFilter(colId) {
    let and = _.get(myFilters, 'mergedFilter.and', []);
    _.remove(and, item => {
      return (item.columnId === colId || (item.or && item.or[0].columnId === colId) || (item.and && item.and[0].columnId === colId));
    });
  }

  function removeFilter(internalId) {
    let and = _.get(myFilters, 'mergedFilter.and', []);
    _.remove(and, {internalId: internalId});
    _.forEach(and, item => {
      if (item.and) {
        _.remove(item.and, {internalId: internalId});
      }
      else if (item.or) {
        _.remove(item.or, {internalId: internalId});
      }
    });

    adjustForSingleOrFilters(and);
  }

  function adjustForSingleOrFilters(filters) {
    _.forEach(filters, item => {
      if (item.or && item.or.length === 1) {
        filters.push(item.or[0]);
      }

      if (item.and && item.and.length === 1) {
        filters.push(item.and[0]);
      }
    });

    _.remove(filters, item => {
      return (item.or && item.or.length < 2) || (item.and && item.and.length < 2);
    });
  }

  function initColumnSelection(column) {
    if (!column) {
      return;
    }

    switch (column.type) {
      case 'string':
        setupStringFilter(column);
        break;
      case 'number':
        setupNumberFilter(column);
        break;
      case 'date':
        setupDateFilter(column);
        break;
      case 'mapped':
        setupMappedFilter(column);
        break;
      case 'duration':
        setupDurationFilter(column);
        break;
      default:
        break;
    }

    if (vm.filtersForm) {
      vm.filtersForm.$setPristine();
      vm.filtersForm.$setUntouched();
    }
  }

  function setupStringFilter(column) {
    let conditions = _.get(column, 'options.filter.supportedOps');
    if (!conditions) {
      conditions = stringOps;
    }
    vm.stringOps = conditions;

    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (found) {
      vm.stringOp = found.op;
      vm.stringValue = found.value;
    }
    else {
      let defaultOp = _.get(column, 'options.filter.defaultOp', 'contains');
      vm.stringOp = defaultOp;
      vm.stringValue = undefined;
    }

    let element = document.getElementById('filter-string-value');
    if (element) {
      element.focus();
    }
  }

  function isNamedFilter(colId) {
    let named = false;
    if (
      myFilters.namedFilter &&
      myFilters.namedFilter.namedColIds &&
      myFilters.namedFilter.namedColIds.indexOf(colId) > -1
    ) {
      named = true;
    }

    return named;
  }

  function stringOpChanged(op) {
    let and =  _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: vm.selectedColumn.id});
    if (found) {
      found.op = op;
      if (op !== 'isEmpty' && op !== 'isNotEmpty' && isEmptyString(vm.stringValue)) {
        removeColumnFilter(vm.selectedColumn.id);
      }
    }
    else {
      if (op === 'isEmpty' || op === 'isNotEmpty') {
        vm.stringValue = undefined;
        addStringFilter();
      }
    }
  }

  function stringValueChanged() {
    if (isEmptyString(vm.stringValue)) {
      removeColumnFilter(vm.selectedColumn.id);
    }
    else {
      addStringFilter();
    }
  }

  function isEmptyString(value) {
    return (value === undefined || value === null || value === '');
  }

  function emptyNumber(value) {
    return (value === undefined || value === null || value === '');
  }

  function addStringFilter() {
    let column = vm.selectedColumn;
    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (!found) {
      let filter = {
        columnId: column.id,
        op: vm.stringOp,
        value: vm.stringValue
      };

      $gzFilters.setInternalId(myFilters, filter);
      and.push(filter);
    }
    else {
      found.value = vm.stringValue;
    }
  }

  function setupNumberFilter(column) {
    let conditions = _.get(column, 'options.filter.supportedOps');
    if (!conditions) {
      conditions = numberOps;
    }
    vm.numberOps = conditions;

    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (found) {
      vm.numberOp = found.op;
      vm.numberBegin = found.begin;
      vm.numberEnd = found.end;
      vm.numberValue = found.value;
    }
    else {
      let defaultOp = _.get(column, 'options.filter.defaultOp', 'equals');
      vm.numberOp = defaultOp;
      vm.numberValue = undefined;
      vm.numberBegin = undefined;
      vm.numberEnd = undefined;
    }
  }

  function numberOpChanged(op) {
    let and =  _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: vm.selectedColumn.id});
    if (found) {
      found.op = op;
      if (op !== 'isEmpty' && op !== 'isNotEmpty') {
        if (emptyNumber(vm.numberValue)) {
          removeColumnFilter(vm.selectedColumn.id);
        }
      }
    }
    else {
      if (op === 'isEmpty' || op === 'isNotEmpty') {
        addNumberFilter();
      }
    }
  }

  function numberValueChanged() {
    if (emptyNumber(vm.numberValue)) {
      removeColumnFilter(vm.selectedColumn.id);
    }
    else {
      addNumberFilter();
    }
  }

  function numberBeginChanged() {
    if (vm.numberBegin === '' || vm.numberEnd === '') {
      removeColumnFilter(vm.selectedColumn.id);
    }
    else {
      addNumberFilter();
    }
  }

  function numberEndChanged() {
    if (vm.numberBegin === '' || vm.numberEnd === '') {
      removeColumnFilter(vm.selectedColumn.id);
    }
    else {
      addNumberFilter();
    }
  }

  function addNumberFilter() {
    let column = vm.selectedColumn;
    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (!found) {
      let filter = {
        columnId: column.id,
        op: vm.numberOp,
        value: vm.numberValue,
        begin: vm.numberBegin,
        end: vm.numberEnd
      };

      $gzFilters.setInternalId(myFilters, filter);
      and.push(filter);
    }
    else {
      found.value = vm.numberValue;
      found.begin = vm.numberBegin;
      found.end = vm.numberEnd;
    }
  }

  function setupDateFilter(column) {
    let conditions = _.get(column, 'options.filter.supportedOps');
    if (!conditions) {
      conditions = dateOps;
    }
    vm.dateOps = conditions;

    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (found) {
      vm.dateOp = found.op ? found.op : 'equals';
      vm.dateValue = found.value ? new Date(found.value) : new Date();
      vm.dateBegin = found.begin ? new Date(found.begin) : new Date();
      vm.dateEnd = found.end ? new Date(found.end) : new Date();
    }
    else {
      vm.dateValue = new Date();
      vm.dateBegin = new Date();
      vm.dateEnd = new Date();
      vm.dateOp = 'equals';
    }
  }

  function dateOpChanged(op) {
    let and =  _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: vm.selectedColumn.id});
    if (found) {
      found.op = op;
    }
    else {
      let filter = {
        columnId: vm.selectedColumn.id,
        op: vm.dateOp,
        value: moment(vm.dateValue).utc().toISOString(),
        begin: moment(vm.dateBegin).utc().toISOString(),
        end: moment(vm.dateEnd).utc().toISOString()
      };
      $gzFilters.setInternalId(myFilters, filter);
      and.push(filter);
    }
  }

  function dateChanged() {
    updateDateFilter();
  }

  function updateDateFilter() {
    let column = vm.selectedColumn;
    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (found) {
      found.value = moment(vm.dateValue).utc().toISOString();
      found.begin = moment(vm.dateBegin).utc().toISOString();
      found.end = moment(vm.dateEnd).utc().toISOString();
    }
  }

  function getMappedImage(value) {
    let column = vm.selectedColumn;
    switch(column.field.mapped.display) {
      case 'active':
      case 'on':
      case 'true':
      case 'yes':
        return value ? 'fa-check-circle status-green' : 'fa-times-circle status-red';
      case 'locked':
        return value ? 'fa-lock status-red' : 'fa-unlock status-green';
      case 'status':
        switch(value.toUpperCase()) {
          case 'OK':
            return 'fa-check-circle status-green';
          case 'WARN':
            return 'fa-exclamation-circle status-yellow';
          case 'ERROR':
            return 'fa-times-circle status-red';
          case 'INFO':
            return 'fa-info-circle status-blue';
          case 'UNKNOWN':
            return 'fa-question-circle';
        }
        break;
      case 'lookup':
        let lookup = _.get(column, 'field.mapped.lookup');
        if (lookup.imageType === 'fa') {
          return 'fa-' + $translate.instant(lookup.imageBase + value);
        }
        break;
      case 'values':
        let values = _.get(column, 'field.mapped.values');
        if (values) {
          let found = _.find(values, {value: value});
          if (found) {
            if (found.imageType === 'fa') {
              return 'fa-' + found.image;
            }
          }
        }
        break;
    }
  }

  function getMappedDisplay(value) {
    let column = vm.selectedColumn;
    switch(column.field.mapped.display) {
      case 'active':
        return value ? $translate.instant('uxf.uxf.Grid_Active') : $translate.instant('uxf.uxf.Grid_Inactive');
      case 'on':
        return value ? $translate.instant('uxf.uxf.Grid_On') : $translate.instant('uxf.uxf.Grid_Off');
      case 'true':
        return value ? $translate.instant('uxf.uxf.Grid_True') : $translate.instant('uxf.uxf.Grid_False');
      case 'yes':
        return value ? $translate.instant('uxf.uxf.Grid_Yes') : $translate.instant('uxf.uxf.Grid_No');
      case 'locked':
        return value ? $translate.instant('uxf.uxf.Grid_Locked') : $translate.instant('uxf.uxf.Grid_Unlocked');
      case 'status':
        switch(value.toUpperCase()) {
          case 'OK':
            return $translate.instant('uxf.uxf.Grid_Ok');
          case 'WARN':
            return $translate.instant('uxf.uxf.Grid_Warn');
          case 'ERROR':
            return $translate.instant('uxf.uxf.Grid_Error');
          case 'INFO':
            return $translate.instant('uxf.uxf.Grid_Info');
          case 'UNKNOWN':
            return $translate.instant('uxf.uxf.Grid_Unknown');
        }
        break;
      case 'lookup':
        let lookup = _.get(column, 'field.mapped.lookup');
        if (lookup) {
          return $gzFields.resolveString(lookup, 'title', value);
        }
        break;
      case 'values':
        let values = _.get(column, 'field.mapped.values');
        let found = _.find(values, {value: value});
        if (found) {
          return $gzFields.resolveString(found, 'title', value);
        }
        break;
    }
  }

  function setupMappedFilter(column) {
    vm.mappedValues = undefined;
    vm.mappedValue = undefined;

    let values;
    switch(column.field.mapped.display) {
      case 'active':
        values = [true, false];
        break;
      case 'on':
        values = [true, false];
        break;
      case 'true':
        values = [true, false];
        break;
      case 'yes':
        values = [true, false];
        break;
      case 'locked':
        values = [true, false];
        break;
      case 'status':
        vm.mappedOps = mappedOps;
        vm.mappedOp = 'matchAny';
        values = ['OK', 'INFO', 'WARN', 'ERROR', 'UNKNOWN'];
        break;
      case 'lookup':
        vm.mappedOps = mappedOps;
        break;
      case 'values':
        vm.mappedOps = mappedOps;
        vm.mappedOp = 'matchAny';
        values = [];
        _.forEach(column.field.mapped.values, value => {
          values.push(value.value);
        });
        break;
    }

    if (values) {
      vm.mappedValues = _.map(values, value => {
        return {
          value,
          display: getMappedDisplay(value),
        };
      });
    }

    vm.mappedSelection = {};
    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (found) {
      //Single value set
      vm.mappedValue = {
        value: found.value,
        display: getMappedDisplay(found.value),
      };
      _.set(vm.mappedSelection, found.value, true);
      if (found.op === 'notEqual') {
        vm.mappedOp = 'exclude';
      }
    }
    else {
      found = _.find(and, item => {
        return (item.or && item.or[0].columnId === column.id) || (item.and && item.and[0].columnId === column.id);
      });

      if (found) {
        if (found.and) {
          vm.mappedOp = 'exclude';
          _.forEach(found.and, filter => {
            _.set(vm.mappedSelection, filter.value, true);
          });
        }
        else if (found.or) {
          vm.mappedOp = 'matchAny';
          _.forEach(found.or, filter => {
            _.set(vm.mappedSelection, filter.value, true);
          });
        }
      }
      else {
        if (vm.mappedValues.length > 0 && column.field.mapped.display !== 'values' && column.field.mapped.display !== 'lookup' && column.field.mapped.display !== 'status') {
          vm.mappedValue = vm.mappedValues[0];
          _.set(vm.mappedSelection, true, true);
        }
      }
    }
  }

  function durationOpChanged(op) {
    let and =  _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: vm.selectedColumn.id});
    if (found) {
      found.op = op;
    }
    else {
      let filter = {
        columnId: vm.selectedColumn.id,
        op: vm.durationOp,
        value: getDurationValue(vm.daysValue, vm.hoursValue, vm.minutesValue, vm.secondsValue)
      };

      $gzFilters.setInternalId(myFilters, filter);
      and.push(filter);
    }
  }

  function setupDurationFilter(column) {
    let conditions = _.get(column, 'options.filter.supportedOps');
    if (!conditions) {
      conditions = durationOps;
    }
    vm.durationOps = conditions;

    let and = _.get(myFilters, 'mergedFilter.and');
    let filter = _.find(and, {columnId: column.id});
    if (filter) {
      vm.durationOp = filter.op;
      let precision = _.get(column, 'field.duration.precision', 'ms');
      let s_ms_adjustment = 1;
      if (precision === 's') {
        s_ms_adjustment = 1000;
      }

      let x = Math.floor(filter.value * s_ms_adjustment / 1000);

      vm.secondsValue = x % 60;
      x = Math.floor(x / 60);
      vm.minutesValue = x % 60;
      x = Math.floor(x / 60);
      vm.hoursValue = x % 24;
      x = Math.floor(x / 24);
      vm.daysValue = x;
    }
    else {
      vm.durationOp = 'greaterThan';
      vm.daysValue = 0;
      vm.hoursValue = 0;
      vm.minutesValue = 0;
      vm.secondsValue = 0;
    }
  }

  function durationValueChanged() {
    let column = vm.selectedColumn;
    let and = _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: column.id});
    if (found) {
      let precision = _.get(column, 'field.duration.precision', 'ms');
      found.value = getDurationValue(precision);
    }
  }

  function getDurationValue(precision) {
    let s_ms_adjustment = 1000;
    if (precision === 's') {
      s_ms_adjustment = 1;
    }

    let d = 0;
    let h = 0;
    let m = 0;
    let s = 0;

    if (vm.daysValue !== undefined && vm.daysValue !== null && vm.daysValue !== '' && vm.daysValue > 0) {
      d = vm.daysValue;
    }

    if (vm.hoursValue !== undefined && vm.hoursValue !== null && vm.hoursValue !== '' && vm.hoursValue > 0) {
      h = vm.hoursValue;
    }

    if (vm.minutesValue !== undefined && vm.minutesValue !== null && vm.minutesValue !== '' && vm.minutesValue > 0) {
      m = vm.minutesValue;
    }

    if (vm.secondsValue !== undefined && vm.secondsValue !== null && vm.secondsValue !== '' && vm.secondsValue > 0) {
      s = vm.secondsValue;
    }

    return d*24*60*60*s_ms_adjustment + h*60*60*s_ms_adjustment + m*60*s_ms_adjustment + s*s_ms_adjustment;
  }

  function mappedOpChanged(op) {
    let and =  _.get(myFilters, 'mergedFilter.and');
    let found = _.find(and, {columnId: vm.selectedColumn.id});
    if (found) {
      // Single Value version exists
      if (op === 'matchAny') {
        found.op = 'equals';
      }
      else {
        found.op = 'notEqual';
      }
    }
    else {
      found = _.find(and, item => {
        return (item.or && item.or[0].columnId === vm.selectedColumn.id);
      });

      if (found) {
        // Multi 'Match Any' version exists
        // Add 'Exclude' (and) version
        let exclude = {and: []};
        _.forEach(found.or, orItem => {
          orItem.op = 'notEqual';
          exclude.and.push(orItem);
        });

        and.push(exclude);

        // Remove 'Match Any' (or) version
        _.remove(and, item => {
          return (item.or && item.or[0].columnId === vm.selectedColumn.id);
        });
      }
      else {
        found = _.find(and, item => {
          return (item.and && item.and[0].columnId === vm.selectedColumn.id);
        });

        if (found) {
          // Multi 'Exclude' version exists
          // Add 'Match Any' (or) version
          let matchAny = {or: []};
          _.forEach(found.and, andItem => {
            andItem.op = 'equals';
            matchAny.or.push(andItem);
          });

          and.push(matchAny);

          // Remove 'Exclude' (and) version
          _.remove(and, item => {
            return (item.and && item.and[0].columnId === vm.selectedColumn.id);
          });
        }
      }
    }
  }

  function mappedValueChanged(value) {
    let and =  _.get(myFilters, 'mergedFilter.and');
    if (value === undefined) {
      _.remove(and, {columnId: vm.selectedColumn.id});
    }
    else {
      let found = _.find(and, {columnId: vm.selectedColumn.id});
      if (found) {
        found.value = value;
      }
      else if (vm.selectedColumn.internal.enabled) {
        let filter = {
          columnId: vm.selectedColumn.id,
          op: 'equals',
          value: value
        };

        $gzFilters.setInternalId(myFilters, filter);
        and.push(filter);
      }
    }
  }

  function toggleMappedValue(value) {
    let mergedFilter =  _.get(myFilters, 'mergedFilter.and');
    let found = _.find(mergedFilter, {columnId: vm.selectedColumn.id});
    if (found) {
      // Single Value version exists
      if (value === found.value) {
        // Removing Existing Value (toggled off)
        removeColumnFilter(vm.selectedColumn.id);
      }
      else {
        let filter = {
          columnId: vm.selectedColumn.id,
          value: value
        };

        // Adding new value to Single Value (Converting to Multi)
        if (vm.mappedOp === 'matchAny') {
          let or = {or: []};
          found.op = 'equals';
          or.or.push(found);

          filter.op = 'equals';
          $gzFilters.setInternalId(myFilters, filter);
          or.or.push(filter);
          mergedFilter.push(or);
        }
        else {
          let and = {and: []};
          found.op = 'notEqual';
          and.and.push(found);

          filter.op = 'notEqual';
          $gzFilters.setInternalId(myFilters, filter);
          and.and.push(filter);
          mergedFilter.push(and);
        }

        _.remove(mergedFilter, {columnId: vm.selectedColumn.id});
      }
    }
    else {
      found = _.find(mergedFilter, item => {
        return (item.or && item.or[0].columnId === vm.selectedColumn.id);
      });

      if (found) {
        // Multi 'Match Any' (or) version exists
        let current = _.find(found.or, {value: value});
        if (current) {
          removeFilter(current.internalId);
        }
        else {
          // Adding Value to filter
          let filter = {
            columnId: vm.selectedColumn.id,
            op: 'equals',
            value: value
          };

          $gzFilters.setInternalId(myFilters, filter);
          found.or.push(filter);
        }
      }
      else {
        found = _.find(mergedFilter, item => {
          return (item.and && item.and[0].columnId === vm.selectedColumn.id);
        });

        if (found) {
          // Multi 'Exclude' (and) version exists
          let current = _.find(found.and, {value: value});
          if (current) {
            removeFilter(current.internalId);
          }
          else {
            // Adding Value to filter
            let filter = {
              columnId: vm.selectedColumn.id,
              op: 'notEqual',
              value: value
            };

            $gzFilters.setInternalId(myFilters, filter);
            found.and.push(filter);
          }
        }
        else {
          // Adding Single Value
          let filter = {
            columnId: vm.selectedColumn.id,
            value: value
          };

          if (vm.mappedOp === 'matchAny') {
            filter.op = 'equals';
          }
          else {
            filter.op = 'notEqual';
          }

          $gzFilters.setInternalId(myFilters, filter);
          mergedFilter.push(filter);
        }
      }
    }
  }

  function disableSubmit(){
    if (vm.filtersForm.$invalid) {
      return true;
    }

    let enabledColumn = _.find(vm.columns, column => {
      return column.internal.enabled === true;
    });

    if (!enabledColumn) {
      return true;
    }

    let disable = false;
    _.forEach(vm.columns, column => {
      if (column.internal.enabled && !filterEnabled(column)) {
        disable = true;
        return false;
      }
    });

    return disable;
  }

  function toggleClicked(column, $event) {
    $event.stopPropagation();
    if ($event && column.id !== _.get(vm, 'selectedColumn.id')) {
      columnClicked(column);
    }
  }

  function toggleEnabled(column) {
    if (column.internal.enabled) {
      switch (column.type) {
        case 'string':
          stringOpChanged(vm.stringOp);
          break;
        case 'number':
          numberOpChanged(vm.numberOp);
          break;
        case 'date':
          dateOpChanged(vm.dateOp);
          break;
        case 'mapped':
          if (_.get(vm, 'mappedValue.value')) {
            mappedValueChanged(vm.mappedValue.value);
          }
          break;
        case 'duration':
          durationOpChanged(vm.durationOp);
          break;
        default:
          break;
      }

      if (vm.filtersForm) {
        vm.filtersForm.$setSubmitted();
      }
    }
    else {
      if (vm.filtersForm) {
        vm.filtersForm.$setPristine();
        vm.filtersForm.$setUntouched();
      }
      removeColumnFilter(column.id);
    }
  }
}
